interface Photo {
  file: string
  alt: string
  caption: string
  width: number
  height: number
  label?: 'Correct' | 'Avoid'
}
const photos: Record<string, Photo[]> = {
  system: [{ file: 'system-check', alt: 'Scott Purdum demonstrating a balanced riding position on horseback', caption: 'Check each part of your position before you begin.', width: 1148, height: 646 }],
  midsection: [{ file: 'midsection', alt: 'Close view of a rider’s pelvis and midsection aligned in the saddle', caption: 'Let the seat bones point down while the lower back stays soft and flat.', width: 1200, height: 800 }],
  'upper-body': [
    { file: 'upper-correct', alt: 'Rider with a neutral upper body and relaxed flat lower back', caption: 'Relaxed shoulders and a neutral lower back.', width: 1200, height: 800, label: 'Correct' },
    { file: 'upper-avoid', alt: 'Rider pulling the shoulders back and over-arching the lower back', caption: 'Shoulders pulled back with the lower back over-arched.', width: 1200, height: 800, label: 'Avoid' },
  ],
  'lower-body': [
    { file: 'lower-correct', alt: 'Balanced lower-leg position with the heel aligned under the hip', caption: 'Heel balanced beneath the hip.', width: 1200, height: 800, label: 'Correct' },
    { file: 'lower-chair', alt: 'Lower leg pushed forward into a chair-seat position', caption: 'Feet pushed too far forward.', width: 1117, height: 745, label: 'Avoid' },
    { file: 'lower-raised', alt: 'Lower leg with the heel raised and weight tipped forward', caption: 'Heel raised and weight tipped forward.', width: 1125, height: 750, label: 'Avoid' },
  ],
  hands: [
    { file: 'hands-correct', alt: 'Rider holding the reins with thumbs up and elbows near the body', caption: 'Thumbs up with the elbows naturally closer to the body.', width: 1200, height: 800, label: 'Correct' },
    { file: 'hands-avoid', alt: 'Rider holding the reins with thumbs facing inward and elbows out', caption: 'Thumbs facing inward and elbows pushed away from the body.', width: 1200, height: 800, label: 'Avoid' },
  ],
  mindset: [{ file: 'mindset', alt: 'Scott Purdum riding with a calm and focused posture', caption: 'Approach each ride with intention and room to learn.', width: 1200, height: 800 }],
  partnership: [{ file: 'partnership', alt: 'Scott Purdum connecting with his horse from the saddle', caption: 'Your horse is your partner in the conversation.', width: 1200, height: 800 }],
}

export function FoundationPhotos({ section }: { section: string }) {
  const items = photos[section]
  if (!items) return null
  return <div className={`foundation-photos foundation-photos-${items.length}`}>
    {items.map(photo => <figure key={photo.file}>
      <img src={`/images/playbooks/riders-foundation/${photo.file}.webp`} alt={photo.alt} width={photo.width} height={photo.height} loading="lazy" />
      <figcaption>{photo.label && <strong className={photo.label === 'Correct' ? 'foundation-correct' : 'foundation-avoid'}>{photo.label}</strong>}{photo.caption}</figcaption>
    </figure>)}
  </div>
}

export function FoundationSystemCheck() {
  return <section className="foundation-system-check" aria-label="The system check">
    <h2>The System Check</h2>
    <p>Complete this five-step guideline to become one with your horse. Use this quick assessment before every ride, no matter which discipline you ride.</p>
    <FoundationPhotos section="system" />
    <ol>{['Midsection', 'Upper body', 'Lower body', 'Hands', 'Mindset'].map(topic => <li key={topic}>{topic}</li>)}</ol>
  </section>
}
